export const tabs = {
	productDetails: {
		label: "Detalhes do produto",
		title: "Detalhes do produto",
		subtitle: "Informações gerais, precificação e estoque",
	},
	storages: {
		label: "Estoques",
		title: "Estoques",
		subtitle: "Veja todos os estoques que esse produto está vinculado",
		table: {
			empty: "Nenhum estoque vinculado",
			columns: {
				storage: "Estoque",
				quantity: "Quantidade",
				value: "Valor em estoque",
			},
		},
	},
	kardex: {
		label: "Ficha Kardex",
		title: "Ficha Kardex",
		subtitle: "A ficha Kardex é uma representação do estoque e movimentações de um item.",
	},
	fiscalData: {
		label: "Dados fiscais",
		title: "Dados fiscais",
		subtitle: "Informações fiscais do produto",
	},
	technicalSheet: {
		label: "Ficha técnica",
		title: "Ficha técnica",
		subtitle:
			"A ficha técnica de produto contém informações sobre materiais, " +
			"medidas e processos, garantindo uma produção mais consistente.",
	},
	bars: {
		label: "Bares",
		title: "Bares",
		subtitle: "Configurações de bares e setores",
	},
	mountableProduct: {
		label: "Produto montável",
		title: "Produto montável",
		subtitle:
			"Os produtos montáveis permitem que o cliente final faça uma combinação a partir de uma base fixa e uma variedade de ingredientes adicionais. No caso do açaí, por exemplo, a base seria o açaí batido e os ingredientes adicionais seriam paçoca, leite ninho e etc.",
	},
	qrcode: {
		label: "QR Code",
		title: "QR Code",
	},
};
